import { colorBrands } from '../colors/colors.brands';

export const skeletonSemantics = {
  'gradient-light': {
    light: colorBrands['neutral-200'],
    dark: colorBrands['neutral-400'],
  },
  'gradient-dark': {
    light: colorBrands['neutral-300'],
    dark: colorBrands['neutral-500'],
  },
};
